import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  productoList,
  productoListSelectBox,
  productoCreate,
  productoRead,
  productoUpdate,
  productoDelete,  
} = actions;

const productoListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/producto/list.php?paramBusqueda=' + paramBusqueda);
      if (response.status === 200 && response.data.data) {       
        dispatch(productoList(response.data.data));
        return
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const productoCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/producto/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const productoReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/producto/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(productoRead(response.data.data));
          return true;
        }
      } else {
        dispatch(productoRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const movimientoCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/producto/inventario.php', data);
      console.log('movimientoCreateAction: ', response);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};
/////////////////

export {
  productoListAction,
  productoCreateAction,
  productoReadAction,  
  movimientoCreateAction,
};
